import React, { Component } from "react";
import { Table, Tag, Row, Col } from "antd";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, dineroDisabledMask } from "../../../../Components/Items";

moment.locale("es");

class ModalPrevisualizarVenta extends Component {
  state = {
    loading: false,
    datos: null,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible !== prevProps.visible) {
      if (this.props.visible) {
        this.consultarVenta();
      } else {
        this.setState({ datos: null });
      }
    }
  }

  consultarVenta() {
    this.setState({ loading: true });
    axios
      .post(
        "ventas/previsualizarVenta",
        { ventaId: this.props.ventaId, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data.success === 2) {
          this.setState({ datos: res.data, loading: false });
        } else {
          this.setState({ datos: null, loading: false });
        }
      })
      .catch(() => {
        this.setState({ datos: null, loading: false });
      });
  }

  verVentaCompleta() {
    this.props.history.push("/panel/verVenta", { id: this.props.ventaId });
    this.props.onCancel();
  }

  renderTagEstado(datos) {
    if (datos.estado === 0) {
      if (datos.facturaId) return <Tag color="purple">Facturada</Tag>;
      if (datos.refacturadoId) return <Tag color="magenta">Refacturada</Tag>;
      return <Tag color="red">Cancelada</Tag>;
    }
    if (datos.estado === 1) return <Tag color="blue">Sin entregar</Tag>;
    if (datos.estado === 2) return <Tag color="orange">Entregado parcialmente</Tag>;
    if (datos.estado === 3) {
      return datos.anticipo ? <Tag color="cyan">Anticipo</Tag> : <Tag color="green">Entregado</Tag>;
    }
    return null;
  }

  render() {
    const { datos } = this.state;

    const columnsInsumos = [
      { title: "Descripción", dataIndex: "descripcion", key: "descripcion" },
      {
        title: "Cantidad",
        dataIndex: "cantidad",
        key: "cantidad",
        align: "right",
        width: 90,
        render: (value) => <span style={{ fontVariantNumeric: "tabular-nums" }}>{value}</span>,
      },
      {
        title: "Precio Unitario",
        dataIndex: "precioUnitario",
        key: "precioUnitario",
        align: "right",
        width: 130,
        render: (value) => (
          <span style={{ fontVariantNumeric: "tabular-nums" }}>{dineroDisabledMask(value)}</span>
        ),
      },
      {
        title: "Importe",
        dataIndex: "total",
        key: "total",
        align: "right",
        width: 130,
        render: (value) => (
          <span style={{ fontVariantNumeric: "tabular-nums" }}>{dineroDisabledMask(value)}</span>
        ),
      },
    ];

    return (
      <ModalItem
        title="Previsualizar Venta"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.props.onCancel}
        paddingTop
        width={800}
      >
        {datos && (
          <div>
            <Row gutter={[16, 4]}>
              <Col span={12}>
                <div style={{ fontSize: 16, fontWeight: 600 }}>{datos.cliente?.nombre}</div>
                <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                  {datos.cliente?.rfc}
                  {datos.cliente?.claveCliente ? ` - ${datos.cliente.claveCliente}` : ""}
                </div>
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                <div style={{ fontSize: 16, fontWeight: 600, color: "#00BFD6" }}>{datos.folio}</div>
                <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                  {moment(datos.fecha).format("DD/MM/YY HH:mm")}
                </div>
              </Col>
            </Row>

            <div style={{ borderBottom: "1px solid #eee", margin: "10px 0" }} />

            <Row gutter={[16, 4]} style={{ marginBottom: 14 }}>
              <Col span={12}>
                <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                  {datos.vendedor ? `Vendedor: ${datos.vendedor}` : ""}
                </div>
                <div style={{ fontSize: 12, color: "#8c8c8c" }}>
                  {datos.proyecto ? `Proyecto: ${datos.proyecto}` : ""}
                </div>
              </Col>
              <Col span={12} style={{ textAlign: "right" }}>
                <div style={{ display: "flex", justifyContent: "flex-end", gap: 6, flexWrap: "wrap" }}>
                  {this.renderTagEstado(datos)}
                  <Tag>{datos.contado === 1 ? "PUE" : "PPD"}</Tag>
                </div>
              </Col>
            </Row>

            <Table
              className="custom-small-table"
              dataSource={datos.insumos}
              columns={columnsInsumos}
              rowKey={(record, index) => index}
              rowClassName={(record, index) => (index % 2 === 0 ? "zebra-gris" : "default")}
              pagination={false}
              size="small"
            />

            <Row justify="end" style={{ marginTop: 14 }}>
              <Col
                style={{
                  textAlign: "right",
                  minWidth: 240,
                  backgroundColor: "#fafafa",
                  border: "1px solid #f0f0f0",
                  borderRadius: 8,
                  padding: "10px 14px",
                }}
              >
                <div style={{ display: "flex", justifyContent: "space-between", gap: 16, fontSize: 12, color: "#8c8c8c" }}>
                  <span>Subtotal</span>
                  <span style={{ fontVariantNumeric: "tabular-nums" }}>
                    {dineroDisabledMask(datos.subtotal)} {datos.moneda}
                  </span>
                </div>
                {datos.arrayImpuestos?.map((impuesto, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", justifyContent: "space-between", gap: 16, fontSize: 12, color: "#8c8c8c" }}
                  >
                    <span>{impuesto.descripcionFactura}</span>
                    <span style={{ fontVariantNumeric: "tabular-nums" }}>
                      {dineroDisabledMask(impuesto.montoImpuesto)} {datos.moneda}
                    </span>
                  </div>
                ))}
                <div style={{ display: "flex", justifyContent: "space-between", gap: 16, fontSize: 12, color: "#8c8c8c" }}>
                  <span>Total</span>
                  <span style={{ fontVariantNumeric: "tabular-nums" }}>
                    {dineroDisabledMask(datos.total)} {datos.moneda}
                  </span>
                </div>
                {datos.arrayRetenciones?.map((retencion, index) => (
                  <div
                    key={index}
                    style={{ display: "flex", justifyContent: "space-between", gap: 16, fontSize: 12, color: "#8c8c8c" }}
                  >
                    <span>{retencion.descripcionFactura}</span>
                    <span style={{ fontVariantNumeric: "tabular-nums" }}>
                      {dineroDisabledMask(retencion.totalRetenciones)} {datos.moneda}
                    </span>
                  </div>
                ))}
                {datos.totalPagar !== datos.total && (
                  <div style={{ display: "flex", justifyContent: "space-between", gap: 16, fontSize: 14, color: "#00BFD6", fontWeight: 700 }}>
                    <span>Total a Pagar</span>
                    <span style={{ fontVariantNumeric: "tabular-nums" }}>
                      {dineroDisabledMask(datos.totalPagar)} {datos.moneda}
                    </span>
                  </div>
                )}
              </Col>
            </Row>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 20 }}>
              <ButtonItem blanco onClick={this.verVentaCompleta.bind(this)}>
                Ver Venta completa
              </ButtonItem>
              <ButtonItem type="primary" danger onClick={this.props.onCancel}>
                Cerrar
              </ButtonItem>
            </div>
          </div>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalPrevisualizarVenta);
